
import { initMarketArchiveStockValue } from "./../js/marketArchiveStockValue/initMarketArchiveStockValue";

initMarketArchiveStockValue("market-archive-stock-value");
